export default __webpack_public_path__ + "static/media/neab.0c000854.png";